import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const FlagIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M1.44688 7.27456C1.3063 6.74991 1.6248 6.20872 2.15826 6.06578C2.69173 5.92284 3.23815 6.23227 3.37873 6.75693L7.19687 21.0064C7.33745 21.531 7.01895 22.0722 6.48548 22.2152C5.95202 22.3581 5.40559 22.0487 5.26501 21.524L1.44688 7.27456Z'
                fill='currentColor'
            />
            <Path
                d='M5.77756 6.07662C7.27093 5.11104 9.08829 4.76961 10.8257 5.12636C12.8921 5.5507 15.0493 5.21309 16.8918 4.17934L18.044 3.53293L19.8593 10.3076L18.2098 11.2339C16.8427 12.0009 15.2298 12.2127 13.7185 11.8246C11.4525 11.2428 9.04247 11.6789 7.12254 13.0016L5.3424 6.35801L5.77756 6.07662Z'
                stroke='currentColor'
                strokeWidth='2'
            />
        </>
    ),
})

FlagIcon.displayName = 'FlagIcon'
